import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RosterReportsPage } from './roster-reports.page';

const routes: Routes = [
  {
    path: '',
    component: RosterReportsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RosterReportsPageRoutingModule {}
